import React, { Component } from 'react';
import { CardComponent, CardNumber, CardExpiry, CardCVV } from '@chargebee/chargebee-js-react-wrapper';
import { connect } from 'react-redux';
import { InvoiceCard, PaymentCard, Modal, ShopifyInvoiceCard } from 'components';
import { getUserBill, deleteUserCard, createUserCard, downloadInvoice, updPrimary } from '../../ducks/billing';//getShopifyBill
import { getProfile } from '../../ducks/auth';
import { confirmAlert } from 'react-confirm-alert';
import './Payment.scss';
import SimpleReactValidator from 'simple-react-validator';
// import { toast } from 'react-toastify';
import toast from '../../components/Toastify';
const moment = require('moment');
import Select from 'react-select';
import SimpleCrypto from 'simple-crypto-js';
import ContentLoader from 'react-content-loader';
const _secretKey = process.env.REACT_APP_SECRET_KEY_FOR_CRYPTO;
const simpleCrypto = new SimpleCrypto(_secretKey);
// import { checkPermission } from 'services/permissions';
let countryIndex = 0;
let ipCountry;
const country = [
  { label: 'Afghanistan', value: 'AF' },
  { label: 'land Islands', value: 'AX' },
  { label: 'Albania', value: 'AL' },
  { label: 'Algeria', value: 'DZ' },
  { label: 'American Samoa', value: 'AS' },
  { label: 'AndorrA', value: 'AD' },
  { label: 'Angola', value: 'AO' },
  { label: 'Anguilla', value: 'AI' },
  { label: 'Antarctica', value: 'AQ' },
  { label: 'Antigua and Barbuda', value: 'AG' },
  { label: 'Argentina', value: 'AR' },
  { label: 'Armenia', value: 'AM' },
  { label: 'Aruba', value: 'AW' },
  { label: 'Australia', value: 'AU' },
  { label: 'Austria', value: 'AT' },
  { label: 'Azerbaijan', value: 'AZ' },
  { label: 'Bahamas', value: 'BS' },
  { label: 'Bahrain', value: 'BH' },
  { label: 'Bangladesh', value: 'BD' },
  { label: 'Barbados', value: 'BB' },
  { label: 'Belarus', value: 'BY' },
  { label: 'Belgium', value: 'BE' },
  { label: 'Belize', value: 'BZ' },
  { label: 'Benin', value: 'BJ' },
  { label: 'Bermuda', value: 'BM' },
  { label: 'Bhutan', value: 'BT' },
  { label: 'Bolivia', value: 'BO' },
  { label: 'Bosnia and Herzegovina', value: 'BA' },
  { label: 'Botswana', value: 'BW' },
  { label: 'Bouvet Island', value: 'BV' },
  { label: 'Brazil', value: 'BR' },
  { label: 'British Indian Ocean Territory', value: 'IO' },
  { label: 'Brunei Darussalam', value: 'BN' },
  { label: 'Bulgaria', value: 'BG' },
  { label: 'Burkina Faso', value: 'BF' },
  { label: 'Burundi', value: 'BI' },
  { label: 'Cambodia', value: 'KH' },
  { label: 'Cameroon', value: 'CM' },
  { label: 'Canada', value: 'CA' },
  { label: 'Cape Verde', value: 'CV' },
  { label: 'Cayman Islands', value: 'KY' },
  { label: 'Central African Republic', value: 'CF' },
  { label: 'Chad', value: 'TD' },
  { label: 'Chile', value: 'CL' },
  { label: 'China', value: 'CN' },
  { label: 'Christmas Island', value: 'CX' },
  { label: 'Cocos (Keeling) Islands', value: 'CC' },
  { label: 'Colombia', value: 'CO' },
  { label: 'Comoros', value: 'KM' },
  { label: 'Congo', value: 'CG' },
  { label: 'Congo, The Democratic Republic of the', value: 'CD' },
  { label: 'Cook Islands', value: 'CK' },
  { label: 'Costa Rica', value: 'CR' },
  { label: 'Cote D\'Ivoire', value: 'CI' },
  { label: 'Croatia', value: 'HR' },
  { label: 'Cuba', value: 'CU' },
  { label: 'Cyprus', value: 'CY' },
  { label: 'Czech Republic', value: 'CZ' },
  { label: 'Denmark', value: 'DK' },
  { label: 'Djibouti', value: 'DJ' },
  { label: 'Dominica', value: 'DM' },
  { label: 'Dominican Republic', value: 'DO' },
  { label: 'Ecuador', value: 'EC' },
  { label: 'Egypt', value: 'EG' },
  { label: 'El Salvador', value: 'SV' },
  { label: 'Equatorial Guinea', value: 'GQ' },
  { label: 'Eritrea', value: 'ER' },
  { label: 'Estonia', value: 'EE' },
  { label: 'Ethiopia', value: 'ET' },
  { label: 'Falkland Islands (Malvinas)', value: 'FK' },
  { label: 'Faroe Islands', value: 'FO' },
  { label: 'Fiji', value: 'FJ' },
  { label: 'Finland', value: 'FI' },
  { label: 'France', value: 'FR' },
  { label: 'French Guiana', value: 'GF' },
  { label: 'French Polynesia', value: 'PF' },
  { label: 'French Southern Territories', value: 'TF' },
  { label: 'Gabon', value: 'GA' },
  { label: 'Gambia', value: 'GM' },
  { label: 'Georgia', value: 'GE' },
  { label: 'Germany', value: 'DE' },
  { label: 'Ghana', value: 'GH' },
  { label: 'Gibraltar', value: 'GI' },
  { label: 'Greece', value: 'GR' },
  { label: 'Greenland', value: 'GL' },
  { label: 'Grenada', value: 'GD' },
  { label: 'Guadeloupe', value: 'GP' },
  { label: 'Guam', value: 'GU' },
  { label: 'Guatemala', value: 'GT' },
  { label: 'Guernsey', value: 'GG' },
  { label: 'Guinea', value: 'GN' },
  { label: 'Guinea-Bissau', value: 'GW' },
  { label: 'Guyana', value: 'GY' },
  { label: 'Haiti', value: 'HT' },
  { label: 'Heard Island and Mcdonald Islands', value: 'HM' },
  { label: 'Holy See (Vatican City State)', value: 'VA' },
  { label: 'Honduras', value: 'HN' },
  { label: 'Hong Kong', value: 'HK' },
  { label: 'Hungary', value: 'HU' },
  { label: 'Iceland', value: 'IS' },
  { label: 'India', value: 'IN' },
  { label: 'Indonesia', value: 'ID' },
  { label: 'Iran, Islamic Republic Of', value: 'IR' },
  { label: 'Iraq', value: 'IQ' },
  { label: 'Ireland', value: 'IE' },
  { label: 'Isle of Man', value: 'IM' },
  { label: 'Israel', value: 'IL' },
  { label: 'Italy', value: 'IT' },
  { label: 'Jamaica', value: 'JM' },
  { label: 'Japan', value: 'JP' },
  { label: 'Jersey', value: 'JE' },
  { label: 'Jordan', value: 'JO' },
  { label: 'Kazakhstan', value: 'KZ' },
  { label: 'Kenya', value: 'KE' },
  { label: 'Kiribati', value: 'KI' },
  { label: 'Korea, Democratic People\'S Republic of', value: 'KP' },
  { label: 'Korea, Republic of', value: 'KR' },
  { label: 'Kuwait', value: 'KW' },
  { label: 'Kyrgyzstan', value: 'KG' },
  { label: 'Lao People\'S Democratic Republic', value: 'LA' },
  { label: 'Latvia', value: 'LV' },
  { label: 'Lebanon', value: 'LB' },
  { label: 'Lesotho', value: 'LS' },
  { label: 'Liberia', value: 'LR' },
  { label: 'Libyan Arab Jamahiriya', value: 'LY' },
  { label: 'Liechtenstein', value: 'LI' },
  { label: 'Lithuania', value: 'LT' },
  { label: 'Luxembourg', value: 'LU' },
  { label: 'Macao', value: 'MO' },
  { label: 'Macedonia', value: 'MK' },
  { label: 'Madagascar', value: 'MG' },
  { label: 'Malawi', value: 'MW' },
  { label: 'Malaysia', value: 'MY' },
  { label: 'Maldives', value: 'MV' },
  { label: 'Mali', value: 'ML' },
  { label: 'Malta', value: 'MT' },
  { label: 'Marshall Islands', value: 'MH' },
  { label: 'Martinique', value: 'MQ' },
  { label: 'Mauritania', value: 'MR' },
  { label: 'Mauritius', value: 'MU' },
  { label: 'Mayotte', value: 'YT' },
  { label: 'Mexico', value: 'MX' },
  { label: 'Micronesia, Federated States of', value: 'FM' },
  { label: 'Moldova, Republic of', value: 'MD' },
  { label: 'Monaco', value: 'MC' },
  { label: 'Mongolia', value: 'MN' },
  { label: 'Montenegro', value: 'ME' },
  { label: 'Montserrat', value: 'MS' },
  { label: 'Morocco', value: 'MA' },
  { label: 'Mozambique', value: 'MZ' },
  { label: 'Myanmar', value: 'MM' },
  { label: 'Namibia', value: 'NA' },
  { label: 'Nauru', value: 'NR' },
  { label: 'Nepal', value: 'NP' },
  { label: 'Netherlands', value: 'NL' },
  { label: 'Netherlands Antilles', value: 'AN' },
  { label: 'New Caledonia', value: 'NC' },
  { label: 'New Zealand', value: 'NZ' },
  { label: 'Nicaragua', value: 'NI' },
  { label: 'Niger', value: 'NE' },
  { label: 'Nigeria', value: 'NG' },
  { label: 'Niue', value: 'NU' },
  { label: 'Norfolk Island', value: 'NF' },
  { label: 'Northern Mariana Islands', value: 'MP' },
  { label: 'Norway', value: 'NO' },
  { label: 'Oman', value: 'OM' },
  { label: 'Pakistan', value: 'PK' },
  { label: 'Palau', value: 'PW' },
  { label: 'Palestinian Territory, Occupied', value: 'PS' },
  { label: 'Panama', value: 'PA' },
  { label: 'Papua New Guinea', value: 'PG' },
  { label: 'Paraguay', value: 'PY' },
  { label: 'Peru', value: 'PE' },
  { label: 'Philippines', value: 'PH' },
  { label: 'Pitcairn', value: 'PN' },
  { label: 'Poland', value: 'PL' },
  { label: 'Portugal', value: 'PT' },
  { label: 'Puerto Rico', value: 'PR' },
  { label: 'Qatar', value: 'QA' },
  { label: 'Reunion', value: 'RE' },
  { label: 'Romania', value: 'RO' },
  { label: 'Russian Federation', value: 'RU' },
  { label: 'RWANDA', value: 'RW' },
  { label: 'Saint Helena', value: 'SH' },
  { label: 'Saint Kitts and Nevis', value: 'KN' },
  { label: 'Saint Lucia', value: 'LC' },
  { label: 'Saint Pierre and Miquelon', value: 'PM' },
  { label: 'Saint Vincent and the Grenadines', value: 'VC' },
  { label: 'Samoa', value: 'WS' },
  { label: 'San Marino', value: 'SM' },
  { label: 'Sao Tome and Principe', value: 'ST' },
  { label: 'Saudi Arabia', value: 'SA' },
  { label: 'Senegal', value: 'SN' },
  { label: 'Serbia', value: 'RS' },
  { label: 'Seychelles', value: 'SC' },
  { label: 'Sierra Leone', value: 'SL' },
  { label: 'Singapore', value: 'SG' },
  { label: 'Slovakia', value: 'SK' },
  { label: 'Slovenia', value: 'SI' },
  { label: 'Solomon Islands', value: 'SB' },
  { label: 'Somalia', value: 'SO' },
  { label: 'South Africa', value: 'ZA' },
  { label: 'South Georgia and the South Sandwich Islands', value: 'GS' },
  { label: 'Spain', value: 'ES' },
  { label: 'Sri Lanka', value: 'LK' },
  { label: 'Sudan', value: 'SD' },
  { label: 'Suriname', value: 'SR' },
  { label: 'Svalbard and Jan Mayen', value: 'SJ' },
  { label: 'Swaziland', value: 'SZ' },
  { label: 'Sweden', value: 'SE' },
  { label: 'Switzerland', value: 'CH' },
  { label: 'Syrian Arab Republic', value: 'SY' },
  { label: 'Taiwan, Province of China', value: 'TW' },
  { label: 'Tajikistan', value: 'TJ' },
  { label: 'Tanzania, United Republic of', value: 'TZ' },
  { label: 'Thailand', value: 'TH' },
  { label: 'Timor-Leste', value: 'TL' },
  { label: 'Togo', value: 'TG' },
  { label: 'Tokelau', value: 'TK' },
  { label: 'Tonga', value: 'TO' },
  { label: 'Trinidad and Tobago', value: 'TT' },
  { label: 'Tunisia', value: 'TN' },
  { label: 'Turkey', value: 'TR' },
  { label: 'Turkmenistan', value: 'TM' },
  { label: 'Turks and Caicos Islands', value: 'TC' },
  { label: 'Tuvalu', value: 'TV' },
  { label: 'Uganda', value: 'UG' },
  { label: 'Ukraine', value: 'UA' },
  { label: 'United Arab Emirates', value: 'AE' },
  { label: 'United Kingdom', value: 'GB' },
  { label: 'United States', value: 'US' },
  { label: 'United States Minor Outlying Islands', value: 'UM' },
  { label: 'Uruguay', value: 'UY' },
  { label: 'Uzbekistan', value: 'UZ' },
  { label: 'Vanuatu', value: 'VU' },
  { label: 'Venezuela', value: 'VE' },
  { label: 'Viet Nam', value: 'VN' },
  { label: 'Virgin Islands, British', value: 'VG' },
  { label: 'Virgin Islands, U.S.', value: 'VI' },
  { label: 'Wallis and Futuna', value: 'WF' },
  { label: 'Western Sahara', value: 'EH' },
  { label: 'Yemen', value: 'YE' },
  { label: 'Zambia', value: 'ZM' },
  { label: 'Zimbabwe', value: 'ZW' }
];


class Payment extends Component {
  constructor(props) {
    super(props);
    // Create ref to assign card-component
    this.cardRef = React.createRef();
    this.state = {
      fn: '',
      ln: '',
      cp: '',
      tn: '',
      ads: '',
      ct: '',
      zip: '',
      cun: 'US',
      st: '',
      crdn: '4111 1111 1111 1111',
      mh: '12',
      yr: '2023',
      cvv: '123',
      pvd: '',
      card: [],
      otherCard: [],
      cbeID: '',
      crdIndex: '',
      currentPaln: [],
      bill: [],
      shopifyBill: [],
      ci: '',
      paymentType: '',
      hideShowDrp: false,
      intDropUniq: '',
      token: '',
      error: '',
      errorObj: {},
      cardLoading: false,
      firstName: '',
      options: {
        // Custom classes - applied on container elements based on field's state
        classes: {},
        style: {
          // Styles for default field state
          base: {
            color: '#a5a5a5',
            fontWeight: '400',
            fontFamily: 'Roboto, Segoe UI, Helvetica Neue, sans-serif',
            fontSize: '14px',
            fontSmoothing: 'antialiased',
          },
          // Styles for invalid field state
          invalid: {
            color: '#e41029',
            '::placeholder': {
              color: '#e41029',
            },
          },
        },
        // locale
        locale: 'en',
        // Custom placeholders
        placeholder: {
          number: '4111 1111 1111 1111',
          expiry: 'MM / YY',
          cvv: '000'
        },
      }
    };
    this.handleChange = this.handleChange.bind(this);
    this.tokenize = this.tokenize.bind(this);
    this.validator = new SimpleReactValidator();
    this.validatorBilling = new SimpleReactValidator();
  }

  componentDidMount() {
    this.getBillingHistory();
    this.props.getProfile();
    // if (localStorage.getItem('pvd') !== 'shopify') {
    //   this.getBillingHistory();
    // }
    // else {
    //   //if user from shopify
    //   this.props.getShopifyBill();
    // }
    //get user location
    fetch('https://extreme-ip-lookup.com/json', {
      method: 'GET',
    }).then(res => res.json())
      .then((data) => {
        if (data.countryCode) {
          ipCountry = data.countryCode;
          this.setState(this.state);
        }
      });

    //toggle payment method class on body click
    let that = this;
    document.body.addEventListener('click', function () {
      if (that.state.hideShowDrp)
        that.setState({ hideShowDrp: false });
    }, true);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.profile && nextProps.profile.cbe) {
      this.state.ci = nextProps.profile.cbe.client_id;
      this.state.pvd = nextProps.profile.pvd;
      this.state.cbeID = nextProps.profile.cbe.client_id;
      this.setState(this.state);
    }
    if (nextProps.profile && nextProps.profile.ads) {
      this.state.fn = nextProps.profile.ads.fn;
      this.state.ln = nextProps.profile.ads.ln;
      this.state.cp = nextProps.profile.ads.cp;
      this.state.tn = nextProps.profile.ads.tn;
      this.state.ads = nextProps.profile.ads.ads;
      this.state.ct = nextProps.profile.ads.ct;
      this.state.zip = nextProps.profile.ads.zip;
      this.state.cun = nextProps.profile.ads.cun;
      this.state.st = nextProps.profile.ads.st;
      this.setState(this.state);
      countryIndex = nextProps.profile.ads.cun != undefined ? country.findIndex(x => x.value == nextProps.profile.ads.cun) : 0;
      if (countryIndex == 0) {
        countryIndex = country.findIndex(x => x.value == 'US');
      }
    }
    else {
      countryIndex = country.findIndex(x => x.value == ipCountry);
      this.state.cun = ipCountry;
      this.setState(this.state);
    }
    if (nextProps.profile && nextProps.profile.crd && nextProps.profile && nextProps.profile.pvd !== 'shopify') {
      this.state.card = [];
      this.state.otherCard = [];
      this.setState(this.state);
      for (let i = 0; i < nextProps.profile.crd.length; i++) {
        if (nextProps.profile.crd[i].ipm) {
          this.state.card.push(nextProps.profile.crd[i]);
        }
        else {
          this.state.otherCard.push(nextProps.profile.crd[i]);
        }
      }
    }
    if (nextProps.lstBill && this.state.currentPaln.length == 0) {
      this.state.bill = nextProps.lstBill;
      if (this.state.bill.length > 0 && this.state.pvd != 'shopify') {
        //show retry button if users last payment get fail from chargebee
        if (this.state.bill[0].pst == 2) {
          this.state.bill[0]['retry'] = true;
        }
      }
      for (let i = 0; i < this.state.bill.length; i++) {
        if (this.state.bill[i].iexp == false) {
          this.state.bill[i].cdt = moment(this.state.bill[i].cdt).format('MMM DD YYYY');
          this.state.bill[i]['price'] = this.state.bill[i].pobj.price / 100;
          this.state.currentPaln.push(this.state.bill[i]);
        }
      }
    }
    //if user from shopify
    if (nextProps.shopifyBill) {
      this.state.shopifyBill = nextProps.shopifyBill;
      for (let i = 0; i < this.state.shopifyBill.length; i++) {
        this.state.shopifyBill[i].cdt = moment(this.state.shopifyBill[i].cdt).format('MMM DD YYYY');
      }
    }
    if (nextProps.newCard) {
      if (nextProps.newCard.status === 'error') {
        this.setState({ cardLoading: false });
      }
    }
  }

  // getCard = () => {
  //   this.props.getUserCard();
  // }

  getBillingHistory = () => {
    this.props.getUserBill();
  }

  deleteCard = (id, i) => {
    confirmAlert({
      closeOnEscape: false,
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            <h1>Confirm to Delete</h1>
            <p>Are you sure to do this.</p>
            <button className='btn-modal-confirm btn-alert-yes  nf-btn-default'
              onClick={() => { this.userCardDelete(id, i), onClose(); }}>
              Yes
            </button>
            <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}>Cancel</button>
          </div>
        );
      }
    });
  }

  handleDropdown = (key) => {
    this.setState({ hideShowDrp: !this.state.hideShowDrp, intDropUniq: key });
  }

  userCardDelete = (id, i) => {
    this.state.crdIndex = i;
    this.props.deleteUserCard(id);
  }

  //setPrimaryCard
  setPrimary = (id) => {
    confirmAlert({
      closeOnEscape: false,
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            <h1>Confirm to set primary</h1>
            <p>Are you sure to do this.</p>
            <button className='btn-modal-confirm btn-alert-yes  nf-btn-default'
              onClick={() => { this.setUserPrimaryCard(id), onClose(); }}>
              Yes
            </button>
            <button className='btn-modal-confirm btn-alert-no nf-btn-white' onClick={onClose}> Cancel</button>
          </div>
        );
      }
    });
  }

  //setUserPrimaryCard
  setUserPrimaryCard = (id) => {
    let obj = {
      ci: this.state.ci,
      cid: id
    };
    this.props.updPrimary(obj);
  }

  //open add card model
  openModal = (type) => {
    this.state.openClose = !this.state.openClose;
    this.state.paymentType = type;
    this.setState(this.state);
  }

  //close Modal
  closeModal = () => {
    this.setState({ openClose: false });
  }

  //onchage event
  handleCardChange = (state, value) => {
    if (state === 'crdn') {
      let formattedText = value.split(' ').join('');
      if (formattedText.length > 0) {
        formattedText = formattedText.match(new RegExp('.{1,4}', 'g')).join(' ');
      }
      this.setState({ [state]: formattedText });
    }
    else {
      this.setState({ [state]: value });
    }
  }

  //createCard
  createCard = () => {
    let that = this;
    if (!that.validator.allValid()) {
      that.validator.showMessages();
      that.forceUpdate();
    } else {
      let card = {
        customer_id: simpleCrypto.encrypt(this.state.cbeID),
        token: simpleCrypto.encrypt(this.state.token),
        address: {
          fn: this.state.fn,
          ln: this.state.ln,
          cp: this.state.cp,
          tn: this.state.tn,
          ads: this.state.ads,
          ct: this.state.ct,
          zip: this.state.zip,
          cun: this.state.cun,
          st: this.state.st,
        }
      };
      if (this.state.paymentType == 'retry') {
        card.type = 'retry';
      }
      this.props.createUserCard(card);
      // this.closeModal();
      this.setState({ token: '' });
    }
  }

  //downloadInvoice
  downloadInvoice = (id) => {
    let obj = {
      iv: id
    };
    this.props.downloadInvoice(obj);
  }

  //handleOnChange
  handleOnChange = (state, value) => {
    if (state == 'cun') {
      countryIndex = country.findIndex(x => x.value == value);
    }
    this.setState({ [state]: value });
  }

  // clear = () => {
  //   // call clear method through the ref
  //   this.cardRef.current.clear();
  // }

  //open model for add card 
  CardModel = () => {
    const { style, classes, locale, placeholder } = this.state.options;
    let isFromShow = 'block';
    let isLoaderShow = 'none';
    if (this.state.cardLoading == true) {
      isFromShow = 'none';
      isLoaderShow = 'block';
    }
    return (
      <CardComponent ref={this.cardRef} className="fieldset field"
        styles={style}
        classes={classes}
        locale={locale}
        placeholder={placeholder}
      >
        <div className="modal-body ">
          <div className="card-new-add" style={{ display: isFromShow }} >
            <form className="form-card">
              <div className="modal-billing-details">
                <h4 className="modal-billing-title">Billing Details</h4>
                <div className="row">
                  <div className="col-xs-6">
                    <div className="nf-group-input mt-20">
                      <label>First Name<span>*</span></label>
                      <input type="text" value={this.state.fn} id="fn" onChange={(e) => this.handleOnChange('fn', e.target.value)} name="fn" className="nf-input" />
                      {this.validatorBilling.message('First Name', this.state.fn, 'required')}
                    </div>
                  </div>
                  <div className="col-xs-6">
                    <div className="nf-group-input mt-20">
                      <label>Last Name<span>*</span></label>
                      <input type="text" value={this.state.ln} onChange={(e) => this.handleOnChange('ln', e.target.value)} name="ln" className="nf-input" />
                      {this.validatorBilling.message('Last Name', this.state.ln, 'required')}
                    </div>
                  </div>
                  <div className="col-xs-6">
                    <div className="nf-group-input mt-20">
                      <label>Company Name</label>
                      <input type="text" value={this.state.cp} onChange={(e) => this.handleOnChange('cp', e.target.value)} name="cp" className="nf-input" />
                      {/* {this.validatorBilling.message('Company Name', this.state.cp, 'required')} */}
                    </div>
                  </div>
                  <div className="col-xs-6">
                    <div className="nf-group-input mt-20">
                      <label>Tax Number</label>
                      <input type="text" value={this.state.tn} onChange={(e) => this.handleOnChange('tn', e.target.value)} name="tn" className="nf-input" />
                      {/* {this.validatorBilling.message('Company Name', this.state.tn, 'required')} */}
                    </div>
                  </div>
                  <div className="col-xs-12">
                    <div className="nf-group-input">
                      <label>Address<span>*</span></label>
                      <input type="text" value={this.state.ads} onChange={(e) => this.handleOnChange('ads', e.target.value)} name="cn" className="nf-input" />
                      {this.validatorBilling.message('Address', this.state.ads, 'required')}
                    </div>
                  </div>
                  <div className="col-xs-6">
                    <div className="nf-group-input">
                      <label>City<span>*</span></label>
                      <input type="text" value={this.state.ct} onChange={(e) => this.handleOnChange('ct', e.target.value)} name="city" className="nf-input" />
                      {this.validatorBilling.message('City', this.state.ct, 'required')}
                    </div>
                  </div>
                  <div className="col-xs-6">
                    <div className="nf-group-input">
                      <label>State<span>*</span></label>
                      <input type="text" value={this.state.st} onChange={(e) => this.handleOnChange('st', e.target.value)} name="state" className="nf-input" />
                      {this.validatorBilling.message('State', this.state.st, 'required')}
                    </div>
                  </div>
                  <div className="col-xs-6">
                    <div className="nf-group-input ">
                      <label>Zip<span>*</span></label>
                      <input type="text" value={this.state.zip} onChange={(e) => this.handleOnChange('zip', e.target.value)} name="zip" className="nf-input" />
                      {this.validatorBilling.message('Zip', this.state.zip, 'required')}
                    </div>
                  </div>
                  <div className="col-xs-6">
                    <div className="nf-group-input">
                      <label>Country<span>*</span></label>
                      <Select isSearchable={true} defaultValue={country[countryIndex]} value={country[countryIndex]} className="nf-select-dropdown nf-select-defaultdd  nf-select-language" options={country} onChange={(e) => this.handleOnChange('cun', e.value)} />
                      {this.validatorBilling.message('Country', this.state.cun, 'required')}
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-bg">
                <div className="nf-group-input mt-20" style={{ position: 'relative' }}>
                  <CardNumber className="ex1-input" />
                  <label className="ex1-label">Card Number</label><i className="ex1-bar"></i>
                </div>
                <div className="row">
                  <div className="col-md-6 col-xs-12">
                    <div className="nf-group-input mt-10 card-date">
                      <CardExpiry className="ex1-input" />
                      <label className="ex1-label">Expiry</label><i className="ex1-bar"></i>
                    </div>
                  </div>
                  <div className="col-md-6 col-xs-12">
                    <div className="nf-group-input mt-10 card-cvw">
                      <CardCVV className="ex1-input" />
                      <label className="ex1-label">CVC</label><i className="ex1-bar"></i>
                    </div>
                  </div>
                </div>
              </div>
              <div className="nf-btn-login mt-30 modal-paymentmethod-ft">
                <button type='button' className={this.state.cardLoading ? 'submit ex1-button nf-btn nf-btn-default' : 'ex1-button nf-btn nf-btn-default'} onClick={this.tokenize}>
                  Create
                </button>
              </div>
            </form>
          </div>
          <div className="card-new-add" style={{ display: isLoaderShow }}>
            <ContentLoader
              height={840}
              width={600}
              speed={3}
              primaryColor="#fff"
              secondaryColor="#eceef4"
            >
              <rect x="13" y="14" rx="0" ry="0" width="140" height="15" />
              <rect x="15" y="48" rx="0" ry="0" width="121" height="13" />
              <rect x="218" y="48" rx="0" ry="0" width="121" height="12" />
              <rect x="423" y="48" rx="0" ry="0" width="121" height="12" />
              <rect x="15" y="74" rx="0" ry="0" width="171" height="44" />
              <rect x="219" y="74" rx="0" ry="0" width="171" height="44" />
              <rect x="425" y="74" rx="0" ry="0" width="171" height="44" />
              <rect x="15" y="139" rx="0" ry="0" width="99" height="13" />
              <rect x="15" y="167" rx="0" ry="0" width="579" height="44" />
              <rect x="15" y="227" rx="0" ry="0" width="73" height="13" />
              <rect x="15" y="257" rx="0" ry="0" width="273" height="44" />
              <rect x="321" y="227" rx="0" ry="0" width="61" height="13" />
              <rect x="320" y="257" rx="0" ry="0" width="270" height="44" />
              <rect x="15" y="320" rx="0" ry="0" width="50" height="13" />
              <rect x="15" y="350" rx="0" ry="0" width="273" height="44" />
              <rect x="321" y="320" rx="0" ry="0" width="99" height="13" />
              <rect x="320" y="350" rx="0" ry="0" width="270" height="44" />
              <rect x="15" y="437" rx="20" ry="20" width="574" height="304" />
              <rect x="198" y="781" rx="0" ry="0" width="190" height="48" />
            </ContentLoader>
          </div>
        </div>
      </CardComponent>
    );
  }

  //card funcation
  tokenize = () => {
    let that = this;
    if (!that.validatorBilling.allValid()) {
      that.validatorBilling.showMessages();
      that.forceUpdate();
    }
    else {
      this.setState({ cardLoading: true });
      // Call tokenize methods through  card component's ref
      this.cardRef.current.tokenize({}).then((data) => {
        console.log('data ====>', data);
        if (data.token.error) {
          this.setState({ cardLoading: false });
          this.setState({ token: '', cardLoading: false, error: 'Enter valid card details' });
          toast.error('Enter valid card details');
        }
        else {
          this.setState({ token: data.token, error: '' });
          this.createCard();
          // this.clear();
        }
      }).catch((error) => {
        this.setState({ errorObj: error, token: '', error: 'Problem while tokenizing your card details' });
      });
    }
  }

  handleChange = (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    this.setState({
      [name]: value
    });
  }
  //end card function


  render() {
    // if (!checkPermission('billing', 'isview', this.props.profile)) {
    //   return false;
    // }
    const { openClose } = this.state;
    return (
      <div className="payment-container main-container">
        <div className="payment-content">
          {
            this.props.loading == false ?
              this.state.currentPaln.length &&
              <div className="current-block current-plan-block">
                <div className="header-sub-title">
                  <h4 className="mb-2">Current Plan</h4>
                </div>
                {
                  this.state.currentPaln.map((p, key) => {
                    return (
                      <div className="card  card-cuurent-paln card-payment-current" key={key}>
                        <div className="card-cuurent-left">
                          <h4>{p.pobj.name} <span>$ {p.price}</span></h4>
                          <div className="remain-text">
                            <p>It will remain active for forever until or unless you change the plan</p>
                          </div>
                        </div>
                        {/* <div className="card-cuurent-right">
                          <div className="change-plan">
                            <Link className="nf-btn  nf-btn-green  nf-btn-min15x" to={`${process.env.REACT_APP_ROUTE_PREFIX}plan`}>Change Plan</Link>
                          </div>
                        </div> */}
                      </div>
                    );
                  })
                }
                {/* <div className="card  card-cuurent-paln card-payment-current">
                  <div className="card-cuurent-left">
                    <h4>{this.state.currentPaln.pobj.name} <span>$ {this.state.currentPaln.price}</span></h4>
                    <div className="remain-text">
                      <p>It will remain active for forever until or unless you change the plan</p>
                    </div>
                  </div>
                  <div className="card-cuurent-right">
                    <div className="change-plan">
                      <Link className="nf-btn  nf-btn-green  nf-btn-min15x" to={`${process.env.REACT_APP_ROUTE_PREFIX}plan`}>Change Plan</Link>
                    </div>
                  </div>
                </div> */}
              </div>
              :
              <div className="card  card-cuurent-paln card-payment-current">
                <div className="card-cuurent-left">
                  <ContentLoader
                    height={19}
                    width={400}
                    speed={3}
                    primaryColor="#fff"
                    secondaryColor="#eceef4"
                  >
                    <rect x="0" y="0" rx="0" ry="0" width="110" height="5" />
                    <rect x="0" y="9" rx="0" ry="0" width="135" height="5" />
                    <rect x="320" y="3.5" rx="0" ry="0" width="45" height="12" />
                  </ContentLoader>
                  <div className="remain-text"></div>
                </div>
              </div>
          }
          <div className="invoce-card-block">
            {
              localStorage.getItem('pvd') !== 'shopify' ?
                <div className="row">
                  <div className="col-sm-7">
                    <InvoiceCard
                      openCloseModal={this.openModal}
                      bill={this.state.bill}
                      downloadInvoice={this.downloadInvoice}
                      loading={this.props.loading}
                    />
                  </div>
                  <div className="col-sm-5">
                    <PaymentCard
                      openCloseModal={this.openModal}
                      onDelete={this.deleteCard}
                      onPrimary={this.setPrimary}
                      card={this.state.card}
                      otherCard={this.state.otherCard}
                      handleDropdown={this.handleDropdown}
                      hideShowDrp={this.state.hideShowDrp}
                      intDropUniq={this.state.intDropUniq}
                      loading={this.props.loading}
                    />
                  </div>
                </div>
                :
                // if user from shopify
                <div className="row">
                  <div className="col-sm-12">
                    <ShopifyInvoiceCard
                      shopifyBill={this.state.shopifyBill}
                      // downloadInvoice={this.downloadInvoice}
                      loading={this.props.loading}
                    />
                  </div>
                </div>
            }
          </div>
        </div>
        <Modal
          id='CardModel'
          className='addCardModel'
          title=''
          content={this.CardModel()}
          openCloseModal={this.closeModal}
          style={
            {
              modalStyle: {
                display: openClose ? 'block' : 'none',
                opacity: openClose ? 1 : 0
              },
              alignModalStyle: {
                top: '230px'
              }
            }
          }
        />

      </div>
    );
  }
}

const mapStateToProps = state => ({
  lstBill: state.getIn(['billing', 'lstBill']),
  shopifyBill: state.getIn(['billing', 'shopifyBill']),
  deleteCard: state.getIn(['billing', 'deleteCard']),
  newCard: state.getIn(['billing', 'newCard']),
  profile: state.getIn(['auth', 'profile']),
  loading: state.getIn(['loading', 'state'])
});

const mapDispatchToProps = {
  getUserBill,
  deleteUserCard,
  createUserCard,
  downloadInvoice,
  updPrimary,
  getProfile,
  // getShopifyBill
};

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(Payment);


// WEBPACK FOOTER //
// ./src/containers/Payment/Payment.js